import * as React from 'react';
import { FormProvider, Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import TagForm from '../TagForm/TagForm';
import { TAG_FORM_DEFAULT_VALUES } from '../TagForm/constants';
import { useModals } from 'hooks/useModals';
import { TTagsEdit } from './TagsEdit.types';
import { useAppDispatch } from 'store/store';
import { TTagFormValues } from '../TagForm/TagForm.types';
import {
  getTagsListAsyncThunk,
  updateTagAsyncThunk,
} from 'store/tags/tags.action';
import { getTagFormSchema } from '../TagForm/TagForm.schema';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';
import { getLocalizationList } from 'store/localization/localization.action';
import { ESupportedLocales } from 'store/localization/localization.enums';

const TagsEdit: TTagsEdit = ({ item }) => {
  const localize = useLocalize();
  const dispatch = useAppDispatch();
  const modals = useModals();

  const tagFormSchema = React.useMemo(
    () => getTagFormSchema(localize),
    [localize]
  );

  const form = useForm<TTagFormValues>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: {
      ...TAG_FORM_DEFAULT_VALUES,
      ...item,
      name: localize(item.name) as string,
    },
    resolver: yupResolver(tagFormSchema) as Resolver<TTagFormValues>,
  });

  const handleSubmit = (data: TTagFormValues) => {
    dispatch(
      updateTagAsyncThunk({
        id: item.id,
        body: { ...data, id: item.id },
        onSuccess: () => {
          modals.closeModal();
          dispatch(getLocalizationList({ locale: ESupportedLocales.EN }));
          dispatch(getTagsListAsyncThunk());
        },
      })
    );
  };

  return (
    <FormProvider {...form}>
      <TagForm onSubmit={handleSubmit} />
    </FormProvider>
  );
};

export default TagsEdit;
